import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
    url: process.env.REACT_APP_OIDC_AUTH_URL!,
    clientId: process.env.REACT_APP_OIDC_CLIENT_ID!,
    realm: process.env.REACT_APP_OIDC_REALM!,
});

// Export init options for ReactKeycloakProvider
// These options improve compatibility with privacy-focused browsers like Brave
export const keycloakInitOptions = {
    checkLoginIframe: false, // Disable iframe checks (blocked by Brave Shields)
    enableLogging: process.env.NODE_ENV === 'development', // Enable logging in dev mode
    pkceMethod: 'S256' as const, // PKCE is required for SPAs to prevent authorization code interception attacks
    responseMode: 'query' as const, // Use query params instead of hash fragments (better for some browsers)
    onLoad: 'check-sso' as const, // Check SSO status on load
};

export default keycloak;